import APP_ACTIONS from '../constants/app-actions';
import localStorageAPI from '../services/local-storage-api';

// let pendingCheckIds = [];

const zones = {
    setAvailableZones: (zones) => ({
        type: APP_ACTIONS.SET_AVAILABLE_ZONES,
        payload: zones,
    }),
    setCurrentZone: (zoneId) => (dispatch, getState) => {
        dispatch({
            type: APP_ACTIONS.SET_CURRENT_ZONE,
            payload: zoneId,
        });
        const { storesGrouped: { data }, currentStore, stores } = getState().stores;
        if (data && data[zoneId]) {
            if (data[zoneId].find((store) => currentStore.id === store.id) === undefined) {
                dispatch({
                    type: APP_ACTIONS.SET_CURRENT_STORE,
                    payload: data[zoneId][0],
                });
            }
        }
        localStorageAPI.save(getState());
    },
};

export default zones;



/** WEBPACK FOOTER **
 ** ./src/actions/zones.js
 **/